export default function Footer() {
  return (
    <div className="jumbotron text-center footer">
      &copy; {new Date().getFullYear()} Stockvia. All rights reserved.
      <div>
        <a href="/privacy-policy">Privacy Policy</a> ·
        <a href="/terms-of-use">Terms of Use</a>
      </div>
    </div>
  );
}
